import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { debounceTime, throttleTime } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { Subscription } from 'rxjs/internal/Subscription';
import { asyncScheduler } from 'rxjs';

@Directive({
    selector: '[appPreventDoubleClick]',
    standalone: false
})
export class PreventDoubleClickDirective implements OnInit, OnDestroy {
  // @Input()
  private throttleTime = 1000;

  @Output()
  throttledClick = new EventEmitter();

  private clicks = new Subject();
  private subscription!: Subscription;

  constructor() { }

  ngOnInit() {
    this.subscription = this.clicks.pipe(
      throttleTime(this.throttleTime)
    ).subscribe(e => this.emitThrottledClick(e));
  }

  emitThrottledClick(e: any) {
    this.throttledClick.emit(e);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }

  // @HostListener('document:keyup', ['$event'])
  // onKeydownHandler(event: KeyboardEvent) {
  //   if (event.key === 'Enter') {
  //     event.preventDefault();
  //     event.stopPropagation();
  //     this.clicks.next(event);
  //   }
  // }
}
